import axios from "axios";

// In development, use localhost. In production, use relative path
const isDevelopment = process.env.NODE_ENV === "development";
const API_URL = isDevelopment ? "http://localhost:3002/api" : "/api";

// Login method
export const login = async (email, password) => {
  if (process.env.NODE_ENV === 'development') {
    console.log("Attempting to login with API URL:", `${API_URL}/auth/login`);
  }
  try {
    const response = await axios.post(`${API_URL}/auth/login`, {
      email,
      password,
    });
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error("Login error:", error);
    }
    throw error;
  }
};

// Logout method (optional, depending on your implementation)
export const logout = () => {
  // Add any client-side cleanup if necessary
};
